import {
  FaFileInvoice,
  FaTachometerAlt,
  FaFileAlt,
  FaUser
} from "react-icons/fa";

function Sidebar({ setPage }) {
  return (
    <aside className="sidebar">

      <img src="/corealpha.jpeg" alt="Logo" className="logo" />

      <h2>GST Invoice</h2>

      <ul>
        <li onClick={() => setPage("dashboard")}>
          <FaTachometerAlt className="menu-icon" />
          Dashboard
        </li>

    {/* <li onClick={() => setOpenMaster(!openMaster)}>
  Master
</li> */}

{/* {openMaster && (
  <ul>
    <li onClick={() => setPage("state")}>State</li>
    
  </ul>
)} */}

<li onClick={() => setPage("invoice")}>
    <FaFileInvoice className="menu-icon" />
 CreateInvoice
</li>

        <li onClick={() => setPage("reports")}>
          <FaFileAlt className="menu-icon" />
          Reports
        </li>

      </ul>

    </aside>
  );
}

export default Sidebar;